import * as TYPES from '../types';

export const addKnowledgeRepositoryAction = (payload) => {
    return {
        type: TYPES.ADD_KR,
        payload: payload
    };
};

export const getAllKnowledgeRepositoryAction = () => {
    return {
        type: TYPES.GET_ALL_KR,
    };
};

export const getAllKnowledgeRepositorySuccessAction = (payload) => {
    return {
        type: TYPES.GET_ALL_KR_SUCCESS,
        payload: payload
    };
};

export const deleteKnowledgeRepositoryAction = (payload) => {
    return {
        type: TYPES.DELETE_KR,
        payload: payload
    };
};

export const editKnowledgeRepositoryAction = (payload) => {
    return {
        type: TYPES.EDIT_KR,
        payload: payload
    };
};

export const updateKnowledgeRepositoryStatusAction = (payload) => {
    return {
        type: TYPES.UPDATE_KR_STATUS,
        payload: payload
    };
};
